import React, { useEffect, useState } from "react";
import {
  TextField,
  Radio,
  RadioGroup,
  Checkbox,
  Button,
  FormControlLabel,
} from '@mui/material/';

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  fieldElement: {
    margin: "10px 0 10px 0 !important",
  },
  wrapper: {
    padding: '25px',
    background: 'white',
    borderRadius: '20px',
  }
});


const Main = () => {
  const classes = useStyles();
  const [is_submitting, setIsSubmitting] = useState(false);
  const [form_data, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
    is_jioswm_pastor: false,
    bus_to: false,
    bus_from: false,
  });

  useEffect(() => {
    console.log(form_data)
  }, [form_data]);

  const handleFieldChange = (e) => {
    console.log(e)
    setFormData({
      ...form_data,
      [e.target.id]: e.target.value
    });
  }

  const handleFieldOnChange = (id, e) => {
    console.log(e.target.value)
    setFormData({
      ...form_data,
      [id]: e.target.value
    });
  }

  const handleFieldSetOnChange = (id, value) => {
    console.log(value)
    setFormData({
      ...form_data,
      [id]: value
    });
  }

  const isValid = () => {
    if (form_data['first_name'] === "") {
      return false;
    }
    if (form_data['last_name'] === "") {
      return false;
    }
    if (form_data['email'] === "") {
      return false;
    }
    if (form_data['mobile_number'] === "") {
      return false;
    }
    if (form_data['is_jioswm_member'] === undefined) {
      return false;
    }

    return true;
  }

  const submitRegistration = () => {
    setIsSubmitting(true);

    fetch('/bookings.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({ booking: form_data })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data)
      if(data.status === "ok") {
        window.location = `/bookings/${data.booking_reference_number}`;
      }
      setIsSubmitting(false);
    })
  }

  return(
    <div style={{height: "100%"}} className={classes.wrapper}>
      <TextField
        autoFocus={true}
        id="first_name"
        label="First Name"
        type="text"
        fullWidth
        variant="outlined"
        className={classes.fieldElement}
        onChange={handleFieldChange}
        disabled={is_submitting}
      />
      <TextField
        id="last_name"
        label="Last Name"
        type="text"
        fullWidth
        variant="outlined"
        className={classes.fieldElement}
        onChange={handleFieldChange}
        disabled={is_submitting}
      />
      <TextField
        id="email"
        label="Email Addresss"
        type="email"
        fullWidth
        variant="outlined"
        className={classes.fieldElement}
        onChange={handleFieldChange}
        disabled={is_submitting}
      />
      <TextField
        id="mobile_number"
        label="Mobile Number"
        type="tel"
        fullWidth
        variant="outlined"
        className={classes.fieldElement}
        onChange={handleFieldChange}
        disabled={is_submitting}
      />
      <hr/>
      <h5>Are you a JIOSWM member?</h5>
      <RadioGroup row onChange={(e) => handleFieldOnChange('is_jioswm_member', e)}>
        <FormControlLabel value="YES" control={<Radio />} label="YES" />
        <FormControlLabel value="NO" control={<Radio />} label="NO" />
      </RadioGroup>

      {form_data['is_jioswm_member'] == "YES" && <>
        <TextField
          id="jioswm_chapter"
          label="JIOSWM Chapter"
          type="text"
          fullWidth
          variant="outlined"
          className={classes.fieldElement}
          onChange={handleFieldChange}
          disabled={is_submitting}
          sx={{marginTop: '10px'}}
        />

        {form_data['is_jioswm_pastor'] == true && <>
          <FormControlLabel control={<Checkbox checked />} label="I'm a JIOSWM Pastor?" onChange={(e) => handleFieldSetOnChange('is_jioswm_pastor', false)} />
        </>}
        {!form_data['is_jioswm_pastor'] === true && <>
          <FormControlLabel control={<Checkbox />} label="I'm a JIOSWM Pastor?" onChange={(e) => handleFieldSetOnChange('is_jioswm_pastor', true)} />
        </>}
      </>}

      {form_data['is_jioswm_member'] == "NO" && <>
        <hr/>
        <h5>Do you belong to a Church/Ministry/Fellowship</h5>
        <RadioGroup row onChange={(e) => handleFieldOnChange('is_other_ministry', e)}>
          <FormControlLabel value="YES" control={<Radio />} label="YES" />
          <FormControlLabel value="NO" control={<Radio />} label="NO" />
        </RadioGroup>
        {form_data['is_other_ministry'] == "YES" && <>
          <TextField
            id="other_ministry"
            label="Church/Ministry/Fellowship Name"
            type="text"
            fullWidth
            variant="outlined"
            className={classes.fieldElement}
            onChange={handleFieldChange}
            disabled={is_submitting}
          />
        </>}
      </>}
      <hr/>
      <h5>Will you avail of the free shuttle service?</h5>

      {form_data['bus_to'] == true && <>
        <FormControlLabel control={<Checkbox checked />} label="YES, On July 2, 2024 from Munoz, Quezon City to Dwelling Place (Cavite)?" onChange={(e) => handleFieldSetOnChange('bus_to', false)} />
      </>}
      {!form_data['bus_to'] === true && <>
      <FormControlLabel control={<Checkbox />} label="YES, On July 2, 2024 from Munoz, Quezon City to Dwelling Place (Cavite)?" onChange={(e) => handleFieldSetOnChange('bus_to', true)} />
      </>}
      <br/>
      {form_data['bus_from'] == true && <>
        <FormControlLabel control={<Checkbox checked />} label="YES, On July 7, 2024 from Dwelling Place (Cavite) to Munoz, Quezon City?" onChange={(e) => handleFieldSetOnChange('bus_from', false)} />
      </>}
      {!form_data['bus_from'] === true && <>
      <FormControlLabel control={<Checkbox />} label="YES, On July 7, 2024 from Dwelling Place (Cavite) to Munoz, Quezon City?" onChange={(e) => handleFieldSetOnChange('bus_from', true)} />
      </>}

      <hr/>
      <Button
        variant="contained"
        size="large"
        disabled={!isValid()}
        onClick={submitRegistration}
      >
        Register Now
      </Button>
    </div>
  )
}

export default Main;
